import React from 'react';
import { subscribe } from 'react-contextual';
import { Container, Row, Col, Progress, Button } from 'reactstrap';
import Tag from '../../tag';
import onClickHandle from '../onClickHandle';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const CampaignPanel = ({
	className, title, description, needed, completed, size, image1, tags, partnerImage, link, tenantConfig
}) => (

		<Container className="panel-padding">
			<Row className={className}>
				<Col {...size.left} className="gi-campaign-image d-flex">
					<img src={`${config.cdnUrl}${image1}`} alt={title} className="gi-background-image" />
					<img className="partner-ngo-image" src={`${config.cdnUrl}${partnerImage}`} alt={title} />
				</Col>
				<Col {...size.right} className="gi-campaign-textbox d-flex justify-content-between f-d-col">
					<div className="campaign-panel-top">
						<div className="tag-row">
							{typeof tags !== 'undefined' ? tags.map((tag, index) => <Tag {...tag} key={index} />) : []}
						</div>
						<h3>{title}</h3>
						<p>{description}</p>
					</div>
					<div className="progress-wrapper">
						<div className="progress-text">
							<span><span className="bold-text">{needed}</span> supporters needed</span>
							<span className="completed bold-text">{completed}% </span>
						</div>
						<Progress value={completed} />
						<a href={link} onClick={(e) => onClickHandle(e, 'campaign-givenow-click', { title, link }, link)}>
							<Button color={tenantConfig.theme.primaryCTA.backgroundColor} 
							className="btn-full-width campaign-panel-givenow">
								Feed a hungry child
					</Button>
						</a>
					</div>
				</Col>
			</Row>
			<style global jsx>
				{
					`
					.campaign-panel-givenow {
						color: ${tenantConfig.theme.primaryCTA.textColor};
						background: ${tenantConfig.theme.primaryCTA.backgroundColor};
					}

					.progress-bar {
						background: ${tenantConfig.theme.secondaryColor} !important
					}
				`
				}
			</style>
		</Container>
	);

CampaignPanel.defaultProps = {
	className: 'gi-campaign-panel d-flex',
	title: 'mission 10 million meals',
	description: 'Join 123 people who have pledged to help our trusted NGO partners make a difference in the lives of countless children by providing them with daily mid day meals.',
	needed: 1270,
	completed: 80,
	size: {
		left: {
			xs: 12,
			sm: 12,
			md: '7',
			lg: '7',
			xl: '7',
		},
		right: {
			xs: 12,
			sm: 12,
			md: '5',
			lg: '5',
			xl: '5',
		},
	},
	tags: [
		{
			type: 'extremeneed',
			design: 'capsule',
		},
	],
	image: '/static/images/campaign/target-image1.jpg',
	partnerImage: '/static/images/campaign/mission-partner-ngo.png',
	link: '#'
};

export default subscribe()(CampaignPanel);
